import { FilterApplied } from '../../../../redux/types/filters'

/**
 * Devuelve un array con los filtros del aviso activo formateados para los breadcrumbs
 */
export const formatFilters = (activeAviso: any, filterTypes: string[]): FilterApplied[] => {
  const filtrosFinal: FilterApplied[] = []

  if (filterTypes.includes('area') && activeAviso.area) {
    filtrosFinal.push({
      type: 'area',
      name: activeAviso.area.nombre,
      id: activeAviso.area.stringId,
      idSemantico: activeAviso.area.idSemantico,
    })
  }

  if (filterTypes.includes('subarea') && activeAviso.subArea) {
    filtrosFinal.push({
      type: 'subarea',
      name: activeAviso.subArea.nombre,
      id: activeAviso.subArea.stringId,
      idSemantico: activeAviso.subArea.idSemantico,
    })
  }

  if (filterTypes.includes('provincia') && activeAviso?.localizacion?.provinciaDetalle) {
    filtrosFinal.push({
      type: 'provincia',
      name: activeAviso.localizacion.provinciaDetalle,
      id: activeAviso.localizacion.provinciaStringId,
      idSemantico: activeAviso.localizacion.provinciaIdSemantico,
    })
  }

  if (filterTypes.includes('localidad') && activeAviso?.localizacion?.localidadDetalle) {
    filtrosFinal.push({
      type: 'localidad',
      name: activeAviso.localizacion.localidadDetalle,
      id: activeAviso.localizacion.localidadStringId,
      idSemantico: activeAviso.localizacion.localidadIdSemantico,
    })
  }

  if (filterTypes.includes('modalidad_trabajo') && activeAviso.modalidadTrabajo) {
    filtrosFinal.push({
      type: 'modalidad_trabajo',
      name: activeAviso.modalidadTrabajo.nombre,
      id: activeAviso.modalidadTrabajo.stringId,
      idSemantico: activeAviso.modalidadTrabajo.idSemantico,
    })
  }

  if (filterTypes.includes('apto_discapacitado') && activeAviso.aptoDiscapacitados) {
    filtrosFinal.push({
      type: 'apto_discapacitado',
      name: 'Postulantes con discapacidad',
      id: activeAviso.aptoDiscapacitados,
      idSemantico: 'discapacitados-apto',
    })
  }

  return filtrosFinal
}
